export const getUsersFrag = `
    id
    titleBeforeName
    name
    surname
    titleAfterName
    email
`;
